import { Container } from "react-bootstrap";
import "animate.css";
import TrackVisibility from "react-on-screen";

const links = [
  { label: "GitHub", href: "https://github.com/Arnav-panjla" },
  { label: "X", href: "https://x.com/ArnavPanjla" },
  { label: "LinkedIn", href: "https://www.linkedin.com/in/arnav-panjla-a71309299/" },
  { label: "Email", href: "mailto:arnavpanjla@gmail.com" },
];

export const Footer = () => {
  return (
    <footer className="footer" id="footer">
      <Container>
        <TrackVisibility once>
          {({ isVisible }) => (
            <div className={`footer-inner ${isVisible ? "animate__animated animate__fadeInUp" : ""}`}>
              <p className="footer-headline">Let's build something.</p>
              <nav className="footer-links">
                {links.map((link) => (
                  <a
                    className="footer-link"
                    key={link.label}
                    href={link.href}
                    target={link.href.startsWith("http") ? "_blank" : undefined}
                    rel="noopener noreferrer"
                  >
                    {link.label}
                  </a>
                ))}
              </nav>
              <p className="footer-legal">
                © {new Date().getFullYear()} Arnav Panjla. All Rights Reserved
              </p>
            </div>
          )}
        </TrackVisibility>
      </Container>
    </footer>
  );
};
